import React from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

function ScanPointSettingsForm(props) {
    const { t } = useTranslation();
    const { scanPoint, loading } = props;

    const formik = useFormik({
        initialValues: {...scanPoint},
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            name: Yup.string()
                .required(t('form.name_required'))
        }),
        onSubmit: values => {
            props.handleScanPointSave(values)
        }
    })

    const { values, errors, touched } = formik;

    return (
        <Form onSubmit={formik.handleSubmit}>
            <Form.Group as={Row} controlId="name" className="required">
                <Form.Label column sm={2}>{t('general.name')}</Form.Label>
                <Col sm={10}>
                    <Form.Control
                        onChange={formik.handleChange}
                        value={values.name}
                        disabled={loading}
                        isInvalid={!!errors.name && touched.name}
                    />
                    {errors.name && touched.name ? (
                        <Form.Control.Feedback type="invalid">
                            {errors.name}
                        </Form.Control.Feedback>
                    ) : null}
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="description">
                <Form.Label column sm={2}>{t('general.description')}</Form.Label>
                <Col sm={10}>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={values.description || ''}
                        onChange={formik.handleChange}
                        disabled={loading}
                    />
                </Col>
            </Form.Group>
            {/*<Row>
                <Form.Label column sm={2}>{t('general.settings')}</Form.Label>
                <Col sm={10}>
                   {/*  <Form.Check
                        type="checkbox"
                        id="commentsEnabled"
                        onChange={formik.handleChange}
                        value={values.commentsEnabled}
                        defaultChecked={values.commentsEnabled}
                        label=" Salli kommentit"
                        disabled={loading}
                    />
                    <Form.Check
                        type="checkbox"
                        id="qrEnabled"
                        onChange={formik.handleChange}
                        value={values.qrEnabled}
                        defaultChecked={values.qrEnabled}
                        label=" Salli QR-koodit"
                        disabled={loading}
                    /> */
                    /* <Form.Check
                        type="checkbox"
                        id="nfcEnabled"
                        onChange={formik.handleChange}
                        value={values.nfcEnabled}
                        defaultChecked={values.nfcEnabled}
                        label={t('scan_points.allow_nfc')}
                        disabled={loading}
                    /> }
                </Col>
            </Row>*/}
            <Form.Group as={Row} style={{ marginTop: '30px' }}>
                <Col sm={{offset: 2, span: 10}}>
                    <Button type="submit">{t('general.save_changes')}</Button>
                </Col>
            </Form.Group>
        </Form>
    )
}

export default ScanPointSettingsForm;